
<template>
  <div class="bgc">
    <div>注：非优惠期内，非本银行转账可能会产生费用。</div>
    <div style="padding-top: 20px">
      工资发放前请确认代发额度，具体步骤如下：
    </div>
    <div style="">
      <p style="margin-top: 10px">
        <b style="color: #409eff"
          >第一步：点击
          <a
            href="https://ebank.cgbchina.com.cn/corporbank/"
            style="color: #409eff"
            target="_bank"
            >广发银行</a
          >
          菜单=》代收代付 =》工资发放</b
        >
      </p>
      <img style="width: 1000px" src="../assets/img/zztips/1.jpg" />

      <p style="margin-top: 30px">
        <b style="color: #409eff">第二步：点击账户明细查询</b>
      </p>
      <img style="width: 1000px" src="../assets/img/zztips/2.jpg" />

      <p style="margin-top: 30px">
        <b style="color: #409eff"
          >第三步：选择起止日期，点击查询，勾选后击确定按钮，最后点击提交。</b
        >
      </p>
      <img style="width: 1000px" src="../assets/img/zztips/3.jpg" />
    </div>
  </div>
</template>

<script>
import { doHandleMonth } from "@/utils/function";
export default {
  data() {
    return {
      detail: {},
      date: {},
    };
  },
  created() {
    let date = new Date(new Date().getTime());
    this.date.year = date.getFullYear(); //获取完整的年份(4位)
    this.date.month = doHandleMonth(date.getMonth() + 1); //获取当前月份(0-11,0代表1月)
    this.date.day = doHandleMonth(date.getDate()); // 获取当前日(1-31)
    this.detail = JSON.parse(this.$route.query.detail);
  },
};
</script>

<style lang="less" scoped>
.bgc {
  width: 1000px;
  // height: 100vh;
  background-color: #fff;
  font-size: 20px;
  margin: 0 auto;
  p {
    margin: 20px 0;
  }
}
.container {
  width: 740px;
  height: 200px;
  margin: 0 auto;
  padding-top: 50px;
  /* background-color: red; */
}
.title {
  text-align: center;
  margin-bottom: 10px;
}
.receiving {
  margin-bottom: 5px;
}
.content {
  text-indent: 2em;
  line-height: 22px;
}
.sign {
  position: relative;
  margin-top: 35px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.image {
  position: absolute;
  width: 235px;
  top: -65px;
  right: -30px;
}
.time {
  margin-top: 10px;
}
.remark {
  margin-top: 40px;
}
</style>